import { Component } from '@verndale/core';
import { setParentBlockSize } from '../utils/dom';

class shortForm extends Component {
  setupDefaults() {
    this.dom = {
      $footnotesBtnShowMore: this.el.querySelectorAll('.short-form__footnotes-cta--show-more'),
      $footnotesBtnShowLess: this.el.querySelectorAll('.short-form__footnotes-cta--show-less'),
      $footnotesContentHiddenWrapper: this.el.querySelectorAll('.short-form__footnotes-content--hidden')
    };

    this.showMoreInitState();
  }

  addListeners() {
    this.dom.$footnotesBtnShowMore.forEach((btn) => {
      btn.addEventListener('click', this.handleFootnotesButtonClick.bind(this));
    });
    this.dom.$footnotesBtnShowLess.forEach((btn) => {
      btn.addEventListener('click', this.handleFootnotesButtonClick.bind(this));
    });
  }

  showMoreInitState() {
    const hiddenWrapper = '80px';
    this.dom.$footnotesContentHiddenWrapper.forEach((wrapper) => {
      const height = Array.from(wrapper.children).reduce((acc, child) => acc + child.offsetHeight, 0);
      if (height <= 80) {
        const footnotesBtnContainer = wrapper.nextElementSibling;
        footnotesBtnContainer.style.display = 'none';
      }
    });
  }

  handleFootnotesButtonClick(e) {
    // find the previous element siblign of its parent
    const hiddenContentWrapper = e.target.parentElement.previousElementSibling;
    hiddenContentWrapper.classList.toggle('short-form__footnotes-content--hidden');
    // find the parent
    const parent = e.target.parentElement;
    parent.classList.toggle('hidden');
  }

}

export default shortForm;
